module.exports = __webpack_public_path__ + "img/wild_comming.22a6cf00.png";